<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;font-size:20px;"><strong>To My Partner, Carmel</strong></p><br/><br/>
<p style="text-indent:0px;">My partner, Carmel, for her support while writing the book and for reminding me, sometimes, of the reason that I wrote this book, which was to educate and help people to understand just how “simple” it can be.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?5c64240b